import React from "react";
import _data from "../../data";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutUs: {}
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
    this.setState({
      aboutUs: _data.aboutUs
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="overflow-hidden">
          <section id="about" className="about-us ptb-100 background-shape-img">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-md-7">
                  <div className="about-content-left section-heading">
                    <h2>
                    We create native apps for Android and iOS<br />
                      <span>using React-Native.</span>
                    </h2>

                    <div className="single-feature mb-4 mt-5">
                      <div className="icon-box-wrap d-flex align-items-center mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-1.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <div>
                          <h5 className="mb-1">Write once, run everywhere</h5>
                          <p className="mb-0">
                            React Native lets us build one high-quality codebase that runs on both iOS and Android—so you launch faster and maintain less.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="single-feature mb-4">
                      <div className="icon-box-wrap mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-2.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <div>
                          <h5 className="mb-1">Proven stack</h5>
                          <p className="mb-0">
                            We use a battle-tested ecosystem and modern engineering practices so your app is stable, secure, and scalable.
                          </p>
                        </div>
                      </div>
                      <p></p>
                    </div>
                    <div className="single-feature mb-4">
                      <div className="icon-box-wrap mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-3.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <div>
                          <h5 className="mb-1">Fast delivery with AI</h5>
                          <p className="mb-0">
                            We leverage AI tools to accelerate research, design, and implementation—shipping faster while keeping code quality high.
                          </p>
                        </div>
                      </div>
                      <p></p>
                    </div>
                    <div className="single-feature mb-4">
                      <div className="icon-box-wrap mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-4.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <div>
                          <h5 className="mb-1">Performance focused</h5>
                          <p className="mb-0">
                            Smooth animations, fast startup, and responsive UX—optimized for real devices.
                          </p>
                        </div>
                      </div>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="about-content-right d-flex justify-content-center justify-content-lg-end justify-content-md-end">
                    <img
                      src="img/image-11.png"
                      alt="about us"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

export default About;
